export const select360Tour = (id: string) => (state: any) => state.tour[id]?.tour360;
